module.exports = __webpack_public_path__ + "static/mindcraft-training-386fd1cf4558f3f36bccd2d085cf2b2b.png";